const allowedTypes = [
  "doc",
  "docx",
  "ppt",
  "pptx",
  "xls",
  "xlsx",
  "rtf",
  "txt",
  "jpg",
  "jpeg",
  "png",
  "ics",
  "svg",
];

const archiveTypes = ["zip", "7z", "rar"];

export const isAllowedAttachment = (extension: string) => {
  return allowedTypes.includes(extension.toLocaleLowerCase() ?? "no");
};

export const isArchiveAttachment = (extension: string) => {
  return archiveTypes.includes(extension.toLocaleLowerCase() ?? "no");
};
